/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import { types, applySnapshot, getSnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../constants/AgenticServiceConstants';

const AgenticGraphModel = types
  .model('AgenticGraphModel', {
    graphData: types.maybeNull(types.frozen()),
    error: types.optional(types.maybeNull(types.string), null)
  })
  .actions((self) => ({
    getGraph(payload) {
      Framework.getEventManager().publish(constants.GET_AGENTIC_GRAPH, { payload });
    },

    setGraphData(data) {
      applySnapshot(self, {
        ...getSnapshot(self),
        graphData: data,
        error: null
      });
    },

    clearGraphData() {
      applySnapshot(self, {
        ...getSnapshot(self),
        graphData: null
      });
    },

    setError(message) {
      applySnapshot(self, {
        ...getSnapshot(self),
        error: message || null
      });
    },

    clearError() {
      applySnapshot(self, {
        ...getSnapshot(self),
        error: null
      });
    },

    resetState() {
      applySnapshot(self, {
        graphData: null,
        error: null
      });
    }
  }));

export default AgenticGraphModel;
